// CrownIcon.jsx - Reusable crown icon component for winners
import { Crown } from "lucide-react";

const CrownIcon = ({ size = 24, style = {}, className = "" }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "-8px",
        left: "-8px",
        zIndex: 10,
        backgroundColor: "rgba(255, 215, 0, 0.9)",
        borderRadius: "50%",
        width: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.4), 0 0 0 2px rgba(255,255,255,0.8)",
        ...style
      }}
      className={`crown-icon ${className}`}
    >
      <Crown
        size={size}
        color="#FFD700"
        fill="#FFD700"
        strokeWidth={1.5}
        style={{ filter: "drop-shadow(0 1px 3px rgba(0,0,0,0.5))" }}
      />
    </div>
  );
};

export default CrownIcon;
